import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const LLMNode = ({ id, data }) => {
  const config = {
    title: 'LLM',
    content: (
      <div className="text-xs text-gray-500 italic">
        This is a Large Language Model.
      </div>
    ),
    handles: [
      {
        type: 'target',
        position: Position.Left,
        id: `${id}-system`,
        style: { top: '33%' },
      },
      {
        type: 'target',
        position: Position.Left,
        id: `${id}-prompt`,
        style: { top: '66%' },
      },
      {
        type: 'source',
        position: Position.Right,
        id: `${id}-response`,
      },
    ],
    width: 220,
    height: 100,
  };

  return <BaseNode id={id} data={data} config={config} />;
};